import * as React from "react";

import { cn } from "@/lib/utils";

export interface InputProps extends React.ComponentProps<"input"> {
  inputMode?: "text" | "email" | "tel" | "url" | "numeric" | "decimal" | "search";
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, inputMode, ...props }, ref) => {
    // Auto-determine inputMode based on type if not specified
    const determinedInputMode = inputMode || (
      type === "email" ? "email" :
      type === "tel" ? "tel" :
      type === "url" ? "url" :
      type === "number" ? "numeric" :
      type === "search" ? "search" :
      undefined
    );

    return (
      <input
        type={type}
        inputMode={determinedInputMode}
        className={cn(
          "flex h-11 w-full rounded-xl border border-border bg-card px-3.5 py-2 ring-offset-background transition-[border-color,box-shadow] duration-200 [transition-timing-function:var(--ease-out-expo)]",
          "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
          "placeholder:text-muted-foreground/70",
          "hover:border-foreground/20",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:border-primary",
          "disabled:cursor-not-allowed disabled:opacity-50",
          "text-[16px] md:text-sm",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
